// log
import store from "../store";

const fetchDataRequest = () => {
  return {
    type: "CHECK_DATA_REQUEST",
  };
};

const fetchDataSuccess = (payload) => {
  return {
    type: "CHECK_DATA_SUCCESS",
    payload: payload,
  };
};

const fetchDataFailed = (payload) => {
  return {
    type: "CHECK_DATA_FAILED",
    payload: payload,
  };
};

export const fetchData = () => {
  return async (dispatch) => {
    dispatch(fetchDataRequest());
    try {
      let totalSupply = await store
        .getState()
        .blockchain.smartContract.methods.totalSupply()
        .call();
      let isActive = await store
        .getState()
        .blockchain.smartContract.methods.isActive()
        .call();
      let isWhitelistActive = await store
        .getState()
        .blockchain.smartContract.methods.isWhitelistSaleActive()
        .call();
      let wlWalletLimit =  await store
        .getState()
        .blockchain.smartContract.methods.getMaxMintForHolders(await store.getState().blockchain.account)
        .call();
      let publicWalletLimit =  await store
        .getState()
        .blockchain.smartContract.methods.publicWalletLimitation()
        .call();
      console.log(store.getState().blockchain.account);
      let balance =  await store
        .getState()
        .blockchain.smartContract.methods.balanceOf(await store.getState().blockchain.account)
        .call();
      // let cost = await store
      //   .getState()
      //   .blockchain.smartContract.methods.cost()
      //   .call();

      console.log(wlWalletLimit);


      dispatch(
        fetchDataSuccess({
          totalSupply,
          isActive,
          isWhitelistActive,
          wlWalletLimit,
          publicWalletLimit,
          balance,
        })
      );
    } catch (err) {
      console.log(err);
      dispatch(fetchDataFailed("Could not load data from contract."));
    }
  };
};
